module.exports = __webpack_public_path__ + "img/rene-aguero.1edf6c62.png";